
<template>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <form class="card-body" @submit.prevent="UPDATE_CONTACT()">
                    <div>
                        <h5>Detalles de dirección</h5>
                        <p>Para cambiar tus datos de dirección, edítalo y guárdalo desde aquí</p>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="form-group mb-2">
                                <small class="input-title">Tel. Casa: </small>
                                <input type="text" class="form-control form-control-sm" v-model="data.phone"
                                    @keypress="NUMBER" :class="errors.phone ? 'is-invalid' : ''">
                                <small class="invalid-feedback" v-for="(error, index) in errors.phone" :key="index">{{ error
                                }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2">
                                <small class="input-title">Tel. Celular: </small>
                                <input type="text" class="form-control form-control-sm" v-model="data.mobil"
                                    @keypress="NUMBER" :class="errors.mobil ? 'is-invalid' : ''">
                                <small class="invalid-feedback" v-for="(error, index) in errors.mobil" :key="index">{{ error
                                }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="d-flex">
                                <div class="w-75">
                                    <div class="form-group mb-2">
                                        <small class="input-title">Tel. Trabajo: </small>
                                        <input type="text" class="form-control form-control-sm" v-model="data.phone_work"
                                            @keypress="NUMBER" :class="errors.phone_work ? 'is-invalid' : ''">
                                        <small class="invalid-feedback" v-for="(error, index) in errors.phone_work"
                                            :key="index">{{ error }}</small>
                                    </div>
                                </div>
                                <div class="w-25 pl-2">
                                    <div class="form-group mb-2">
                                        <small class="input-title">Ext.: </small>
                                        <input type="text" class="form-control form-control-sm"
                                            v-model="data.phone_work_ext" @keypress="NUMBER"
                                            :class="errors.phone_work_ext ? 'is-invalid' : ''">
                                        <small class="invalid-feedback" v-for="(error, index) in errors.phone_work_ext"
                                            :key="index">{{ error }}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2">
                                <small class="input-title">Otro: </small>
                                <input type="text" class="form-control form-control-sm" v-model="data.phone_other"
                                    @keypress="NUMBER" :class="errors.phone_other ? 'is-invalid' : ''">
                                <small class="invalid-feedback" v-for="(error, index) in errors.phone_other" :key="index">{{
                                    error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2">
                                <small class="input-title">Entregar en: </small>
                                <v-select v-model="data.deliver_to" :items="delivers" hide-details @change="FRESH"
                                    class="form-control form-control-sm" :class="errors.branch ? 'is-invalid' : ''">
                                </v-select>
                                <small class="invalid-feedback" v-for="(error, index) in errors.deliver_to" :key="index">{{
                                    error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6" v-if="data.deliver_to == 1">
                            <div class="form-group mb-2">
                                <small class="input-title">Sucursal: </small>
                                <v-select v-model="data.branch_office_id" item-value="id" item-text="name"
                                    :items="branch_offices" hide-details class="form-control form-control-sm"
                                    :class="errors.branch_office_id ? 'is-invalid' : ''">
                                </v-select>
                                <small class="invalid-feedback" v-for="(error, index) in errors.branch_office_id"
                                    :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6" v-else>
                            <div class="form-group mb-2">
                                <small class="input-title">Dirección: </small>
                                <input type="text" class="form-control form-control-sm" v-model="data.address"
                                    :class="errors.address ? 'is-invalid' : ''">
                                <small class="invalid-feedback" v-for="(error, index) in errors.address" :key="index">{{
                                    error }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="data.deliver_to == 0">
                        <div class="col-lg-3">
                            <div class="form-group mb-2">
                                <small class="input-title">País: </small>
                                <v-select v-model="data.country_id" :items="countries" item-text="name" item-value="id"
                                    hide-details @change="PROVINCES" class="form-control form-control-sm"
                                    :class="errors.country_id ? 'is-invalid' : ''">
                                </v-select>
                                <small class="invalid-feedback" v-for="(error, index) in errors.country_id" :key="index">{{
                                    error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="form-group mb-2">
                                <small class="input-title">Provincia: </small>
                                <v-select v-model="data.province_id" :items="provinces" item-text="name" item-value="id"
                                    hide-details @change="CITIES" class="form-control form-control-sm"
                                    :class="errors.province_id ? 'is-invalid' : ''">
                                </v-select>
                                <small class="invalid-feedback" v-for="(error, index) in errors.province_id" :key="index">{{
                                    error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="form-group mb-2">
                                <small class="input-title">Cuidad: </small>
                                <v-select v-model="data.city_id" :items="cities" item-text="name" item-value="id"
                                    hide-details @change="DISTRICTS" class="form-control form-control-sm"
                                    :class="errors.city_id ? 'is-invalid' : ''">
                                </v-select>
                                <small class="invalid-feedback" v-for="(error, index) in errors.city_id" :key="index">{{
                                    error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="form-group mb-2">
                                <small class="input-title">Distrito: </small>
                                <v-select v-model="data.district_id" :items="districts" item-text="name" item-value="id"
                                    hide-details class="form-control form-control-sm"
                                    :class="errors.district_id ? 'is-invalid' : ''">
                                </v-select>
                                <small class="invalid-feedback" v-for="(error, index) in errors.district_id" :key="index">{{
                                    error }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12">
                            <div class="form-group">
                                <button class="btn btn-success btn-sm">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Guardar detalles</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

</template>
<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters([
            'user',
        ]),
    },
    data () {
        return {
            data: {},
            errors: {},
            delivers: [
                { value: 0, text: 'Dirección' },
                { value: 1, text: 'Sucursal' }
            ],
            countries: [],
            provinces: [],
            cities: [],
            districts: [],
            branch_offices: [],
            count: 0
        }
    },
    created () {
        let vue = this
        vue.data = vue.user
        if(vue.data.deliver_to == 0){
            vue.COUNTRIES()
        }else{
            if(vue.data.deliver_to == 1){
                vue.BRANCH_OFFICES()
            }
        }
    },
    methods: {
        BRANCH_OFFICES: function(){
            let vue = this
            axios({url: '/all/branch-offices', method: 'GET' })
            .then((resp) => {
                vue.branch_offices = resp.data
            })
            .finally((resp) => {
                if(vue.data.country_id){
                    vue.PROVINCES()
                }
            })
        },
        COUNTRIES: function(){
            let vue = this
            axios({url: '/locations/countries', method: 'GET' })
            .then((resp) => {
                vue.countries = resp.data
            })
            .finally((resp) => {
                if(vue.data.country_id){
                    vue.PROVINCES()
                }
            })
        },
        PROVINCES: function(){
            let vue = this
            axios({url: '/locations/provinces/'+ vue.data.country_id, method: 'GET' })
            .then((resp) => {
                vue.provinces = resp.data
            })
            .finally((resp) => {
                if(vue.data.province_id){
                    vue.CITIES()
                }
            })
        },
        CITIES: function(){
            let vue = this
            axios({url: '/locations/cities/'+ vue.data.province_id, method: 'GET' })
            .then((resp) => {
                vue.cities = resp.data
            })
            .finally((resp) => {
                if(vue.data.city_id){
                    vue.DISTRICTS()
                }
            })
        },
        DISTRICTS: function(){
            let vue = this
            axios({url: '/locations/districts/'+ vue.data.city_id, method: 'GET' })
            .then((resp) => {
                vue.districts = resp.data
            })
        },
        UPDATE_CONTACT: function(){
            let vue = this
            vue.count++
            if(vue.count == 1){
                vue.errors = {}
                let data = {
                    phone: vue.data.phone,
                    mobil: vue.data.mobil,
                    phone_work: vue.data.phone_work,
                    phone_work_ext: vue.data.phone_work_ext,
                    phone_other: vue.data.phone_other,
                    deliver_to: vue.data.deliver_to,
                    branch_office_id: vue.data.branch_office_id,
                    address: vue.data.address,
                    country_id: vue.data.country_id,
                    province_id: vue.data.province_id,
                    city_id: vue.data.city_id,
                    district_id: vue.data.district_id,
                    option: 2
                }
                setTimeout(() => {
                    axios({url: '/me', method: 'POST', data: data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$store.dispatch('PROFILE', resp.data.data)
                    })
                    .catch((err) => {
                        if(err.response.status !== 422){
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp)=>{
                        vue.count = 0
                    })
                }, 1000)
            }
        },
    },
    watch: {
        data: {
            handler(e) {
                let vue = this
                if(e.deliver_to == 0){
                    vue.COUNTRIES()
                }else{
                    if(e.deliver_to == 1){
                        vue.BRANCH_OFFICES()
                    }
                }
            },
            deep: true
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/profile/tabs/Contact.vue